import { createFileRoute } from '@tanstack/react-router'
import { omit } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { StudentCard } from '@/entities/student'
import { useStudentItem } from '@/shared/api/student'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/canteen/user-comments/student/$studentId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { studentId } = Route.useParams()
  const { data: studentData, isLoading, isError } = useStudentItem({ id: studentId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка ученика')}>
      <StudentCard
        student={studentData?.student}
        avatarStatus={omit(studentData, 'student')}
        isLoading={isLoading}
        isError={isError}
      />
    </Offcanvas>
  )
}
